import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Accordion from "@/components/core/Accordion/Accordion"
import PreviewCartTile from "@/components/PreviewCart/v1/PreviewCartTile"
import { setShowShippingDetails } from "@/store/features/cartSlice"
import { selectCartState } from "@/store/features/cartSlice"
import { getEventInfoAnalytics } from "@/components/cart/OrderSummary/ShippingInfo/analytics"
import { getCartCount } from "@/utils/cart"

const ShippingInfo = props => {
  const {
    i18n,
    cartItems = [],
    shippingItems = [],
    data: { presetConfigs = "" } = {},
  } = props

  const dispatch = useDispatch()
  const { showShippingDetailsForReview } = useSelector(selectCartState)
  const [shipItems, setShipItems] = useState([])

  const [accordionStatus, setAccordionStatus] = useState({
    Parcel: false,
    LTL: false,
    Services: false,
  })

  const cartCount = getCartCount()

  useEffect(() => {
    const parcelItems = []
    const bundleParent = cartItems.filter(prod => prod.isBundleParent) ?? []
    parcelItems.push(...bundleParent)

    shippingItems.map(item => {
      const { parentLineItemId = "", lineItemId = "" } = item
      if (parentLineItemId) {
        const comboChild = cartItems.find(prod => prod.id === lineItemId) || {}
        if (parcelItems.find(prod => prod.id === parentLineItemId)) {
          const comboParent =
            parcelItems.find(prod => prod.id === parentLineItemId) || {}
          comboParent.childItems?.push(comboChild)
        } else {
          const comboParent = {
            ...(cartItems.find(prod => prod.id === parentLineItemId) || {}),
          }
          comboParent.childItems = [comboChild]
          parcelItems.push(comboParent)
        }
      } else {
        const cartItem = cartItems.find(prod => prod.id === lineItemId) || {}
        parcelItems.push(cartItem)
      }
    })
    setShipItems(parcelItems)
  }, [shippingItems, cartItems])

  const updateStatus = (type, status) => {
    setAccordionStatus({
      ...accordionStatus,
      ...{ status },
    })
    dispatch(
      setShowShippingDetails({
        ...showShippingDetailsForReview,
        [type]: status,
      })
    )
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="shipping-accordion">
          <div className="shipping-accordion__separator" />
          {shippingItems && (
            <Accordion
              isOpen={false}
              title={i18n.inYourCart(shipItems ? cartCount : "  ")}
              analyticTitleData={getEventInfoAnalytics({
                type: "Parcel",
                accordionStatus,
              })}
              handleOpen={() => updateStatus("Parcel", true)}
              handleClose={() => updateStatus("Parcel", false)}
            >
              {shipItems.map((item, i) => {
                if (item?.id) {
                  return (
                    <React.Fragment key={i}>
                      <PreviewCartTile
                        i18n={i18n}
                        checkoutMode={true}
                        currencySign={props.currencySign}
                        data={item}
                        productEventInfo={getEventInfoAnalytics({
                          type: "Parcel",
                          needsProductInfo: true,
                          productName: item.name || item.desc,
                          accordionStatus,
                          isBundle: item?.isBundleParent,
                        })}
                        presetConfigs={presetConfigs}
                      />
                    </React.Fragment>
                  )
                }
              })}
            </Accordion>
          )}
        </div>
      </div>
    </div>
  )
}

export default ShippingInfo
